import HoverMenu from './hover-menu/hover-menu';
import hoverMenuStyles from './hover-menu/hover-menu.module.scss';
import { getMenuGaAttributes } from './site-header.analytics.js';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import * as MenuItem from 'tradera/components/menu-item/menu-item';
import AuctionIcon from '@tradera/blueprint/theme/icons2/auction.svg?jsx';
import WinningIcon from '@tradera/blueprint/theme/icons2/winning.svg?jsx';
import RatingPositiveIcon from '@tradera/blueprint/theme/icons2/rating-positive.svg?jsx';
import HeartIcon from '@tradera/blueprint/theme/icons2/heart.svg?jsx';
import BookmarkIcon from '@tradera/blueprint/theme/icons2/bookmark.svg?jsx';
import StarIcon from '@tradera/blueprint/theme/icons2/star.svg?jsx';
import { myTraderaUrls } from 'tradera/apps/my-tradera/app/pages/routes';
import { Divider } from 'tradera/components/divider/divider';

const getGaAttributes = (label: string) =>
    getMenuGaAttributes('Top navigation', 'Buying menu', label);

export const BuyMenu = ({ showMenu }: { showMenu: boolean }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <HoverMenu
            showMenu={showMenu}
            className={hoverMenuStyles.alignSm27Lg50}>
            <MenuItem.Wrapper>
                <MenuItem.Button
                    href={toLocalizedUrl('/my/wish-list')}
                    className="px-2"
                    icon={<HeartIcon className="icon icon-md mr-1" />}
                    brandColorOnHover
                    {...getGaAttributes('Wishlist')}>
                    {t('siteHeader_wishlist')}
                </MenuItem.Button>
                <MenuItem.Button
                    href={toLocalizedUrl('/my/saved-searches')}
                    className="px-2"
                    icon={<BookmarkIcon className="icon icon-md mr-1" />}
                    brandColorOnHover
                    {...getGaAttributes('Saved searches')}>
                    {t('siteHeader_savedSearches')}
                </MenuItem.Button>
                <MenuItem.Button
                    href={toLocalizedUrl('/my/seller-list')}
                    className="px-2"
                    icon={<StarIcon className="icon icon-md mr-1" />}
                    brandColorOnHover
                    {...getGaAttributes('Seller list')}>
                    {t('siteHeader_sellerList')}
                </MenuItem.Button>
                <Divider thick className="my-0" />
                <MenuItem.Button
                    href={toLocalizedUrl('/my/purchases')}
                    className="px-2"
                    icon={<WinningIcon className="icon icon-md mr-1" />}
                    brandColorOnHover
                    {...getGaAttributes('Won / Bought')}>
                    {t('siteHeader_boughtItems')}
                </MenuItem.Button>
                <MenuItem.Button
                    href={toLocalizedUrl(myTraderaUrls.bidding)}
                    className="px-2"
                    icon={<AuctionIcon className="icon icon-md mr-1" />}
                    brandColorOnHover
                    {...getGaAttributes('Ongoing auctions')}>
                    {t('siteHeader_ongoingAuctions')}
                </MenuItem.Button>
                <MenuItem.Button
                    href={toLocalizedUrl('/my/leave-feedback/buyer')}
                    className="px-2"
                    border={false}
                    icon={<RatingPositiveIcon className="icon icon-md mr-1" />}
                    brandColorOnHover
                    {...getGaAttributes('Rate seller')}>
                    {t('siteHeader_rateSeller')}
                </MenuItem.Button>
            </MenuItem.Wrapper>
        </HoverMenu>
    );
};
